import { render, staticRenderFns } from "./ProcesarPago.vue?vue&type=template&id=b2c15c2a"
import script from "./ProcesarPago.vue?vue&type=script&lang=js"
export * from "./ProcesarPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports